export class DeviceHandler {
	deviceType = "unknown";

	deviceHandler = null;

	deviceControls;

	target = null;

	player = null; //The player entity

	/**
	 *
	 * @param deviceType is the type of device this handler is for
	 * @param deviceHandler is the class handling local event forwarding
	 */
	constructor(deviceType, deviceHandler) {
		this.deviceHandler = deviceHandler
		this.deviceType = deviceType;
	}

	init() {
		//STUB
	}

	animate() {
		//STUB
	}

	bind(camera, domElement) {
		this.deviceControls = this.deviceHandler.bindControls()
	}

	setupListeners() {
		//STUB
	}

	getDeviceControls() {
		return this.deviceControls
	}

	getDeviceType() {
		return this.deviceType;
	}

	setTarget(target) {
		this.target = target;
	}

	isFreeFly() {
		return false;
	}

	setPlayer(ent) {
		this.player = ent
	}
}